module.exports = __webpack_public_path__ + "static/media/phone-icon.1b994df4.svg";